import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYellowCard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 3.3335,
		y: 1.3335,
		width: 9.33333,
		height: 13.3333,
		rx: 1,
		fill: "#F2D90D"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.71946 11.8097C11.6844 10.3811 10.7019 1.3335 10.7019 1.3335L12.0002 1.3335C12.3684 1.3335 12.6668 1.63197 12.6668 2.00016L12.6668 14.0002C12.6668 14.3684 12.3684 14.6668 12.0002 14.6668L4.00016 14.6668C3.63197 14.6668 3.3335 14.3684 3.3335 14.0002L3.3335 12.7621C3.3335 12.7621 7.75455 13.2383 9.71946 11.8097Z",
		fill: "black",
		fillOpacity: .1
	})]
});
export default SvgYellowCard;
